import Vue from 'vue'

/**
 * 保留小数
 * @param val
 * @param fix
 * @returns {string}
 */
export const parseDouble = (val, fix) => {
  let _fix = fix || 2
  let _val = val || 0
  return _val.toFixed(_fix)
}

/**
 * 格式化人民币
 * @param num 金额，默认0
 * @param digit 小数位，默认2
 * @param group 千分位，默认有
 * @param symbol 人民币标志￥，默认无
 * @returns {string}
 */
export const parseCNY = (num = 0,
                         digit = 2,
                         group = true,
                         symbol = false) => {
  num = num === null ? 0 : num
  if (symbol) {
    return num.toLocaleString('zh', {
      style: 'currency',
      currency: 'CNY',
      minimumFractionDigits: digit,
      maximumFractionDigits: digit,
      useGrouping: group
    })
  }
  return num.toLocaleString('zh', {
    minimumFractionDigits: digit,
    maximumFractionDigits: digit,
    useGrouping: group
  })
}

/**
 * 千分位格式化
 * @param num 数字，默认0
 * @param group 千分位，默认有
 * @returns {string}
 */
export const parseGroup = (num = 0,
                           group = true) => {
  num = num === null ? 0 : num
  return num.toLocaleString('zh', {
    useGrouping: group
  })
}

Vue.filter('parseDouble', parseDouble)
Vue.filter('parseCNY', parseCNY)
Vue.filter('parseGroup', parseGroup)



// WEBPACK FOOTER //
// ./src/utils/format/double.js